<template>
    <form-view class="service-custom-view" @submitsuccess="redirect">
        <template slot="field">
            <veui-field label="应用名称："
                name="appId"
                field="appId"
                rules="required">
                <search-select
                    :options="store.appDatasource"
                    v-model="store.formData.appId"
                    :readonly="isEdit || isDetail"
                    placeholder="请选择"/>

                <veui-link v-if="isCreate"
                    ui="link primary"
                    to="/app/create">新建应用</veui-link>
            </veui-field>
            <veui-field label="服务名称："
                name="name"
                field="name"
                tip="最多可输入20个字符"
                :rules="validator('required|name|maxLength:20=名称长度不得超过20个字符')">
                <veui-input
                    v-model="store.formData.name"
                    :readonly="isDetail"
                    placeholder="数字、字母、汉字"/>
            </veui-field>
            <veui-field label="服务描述："
                name="description"
                field="description"
                tip="最多可输入150个字符"
                :rules="validator('required|maxLength:150=描述长度不得超过150个字符')">
                <veui-textarea
                    v-model="store.formData.description"
                    :readonly="isDetail"/>
            </veui-field>
        </template>
        <template slot="operation">
            <template v-if="isCreate || isEditDraft">
                <veui-button v-if="isCreate" ui="primary" @click="setOperationType('api')" type="submit">保存并进入API管理</veui-button>
                <veui-button class="primary-border-btn"
                    type="submit"
                    @click="setOperationType('back')">保存为草稿</veui-button>
            </template>
            <template v-else-if="isEdit">
                <veui-button ui="primary" @click="setOperationType('back')" type="submit">修改完成</veui-button>
            </template>
            <veui-button @click="back">{{ isDetail ? '返回服务列表' : '取消' }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Steps, Field, Button, Input, Span, Dialog, Textarea, Link} from 'veui';
import SearchSelect from '@/common/components/SearchSelect';
import serviceMixin from '@/common/mixins/service';
import pageTypeMixin from '@/common/mixins/pageType';

export default createView(FormView, FormModel, {
    name: 'AccountView',
    data() {
        return {
            operationType: null
        };
    },
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button,
        'veui-steps': Steps,
        'veui-dialog': Dialog,
        'veui-textarea': Textarea,
        'veui-link': Link,
        SearchSelect
    },
    mixins: [serviceMixin, pageTypeMixin],
    methods: {
        setOperationType(type) {
            this.operationType = type;
        },
        redirect({id}) {
            if (this.operationType === 'api') {
                let appId = this.store.getRouteParams().appId;
                appId = appId ? `${appId}/` : '';
                let url = `/app/${appId}service/${id}/custom/api/list`;
                this.global.redirect({url, type: 'push'});
            }
            else if (this.operationType === 'back') {
                this.back();
            }
        }
    }
});
</script>

<style lang="less">
@import '~veui-theme-one/variables.less';

.service-custom-view {
    .veui-field .veui-link {
        line-height: @veui-height-normal;
    }
    .award-item {
        display: block;
    }
}
</style>
